import * as types from '../types.js';
import { formatLotNumber } from '../../versa/misc.js';

export default async function(records)
{
	return `
		<style>
			.view th:nth-child(1)	{ width: 1rem; }
			.view td:nth-child(2)	{ text-align: left; max-width: 10rem; }
			.view td:nth-child(3)	{ text-align: right; }
			.view td:nth-child(4)	{ text-align: right; }
			.view td:nth-child(5)	{ text-align: left; max-width: 20rem; }
			.view td:nth-child(6)	{ text-align: left; }
			.view td:nth-child(7)	{ text-align: left; }
			.view td:nth-child(8)	{ text-align: left; }
			.view td:nth-child(9)	{ text-align: center; }
			.view td:nth-child(10)	{ text-align: center; }
			.view td:nth-child(11)	{ text-align: right; }
			.view td:nth-child(12)	{ text-align: left; }
			.view td:nth-child(13)	{ text-align: left; max-width: 14rem; }
		</style>
		<table class="view">
			<thead>
				<tr>
					<th><input type="checkbox" title="Limpar seleções"></th>
					<th data-index="1" data-visible="${this.visible[0]}">Empresa</th>
					<th data-index="2" data-visible="${this.visible[1]}">Lote</th>
					<th data-index="3" data-visible="${this.visible[2]}">Entrada</th>
					<th data-index="4" data-visible="${this.visible[3]}">Produto</th>
					<th data-index="5" data-visible="${this.visible[4]}">Programa</th>
					<th data-index="6" data-visible="${this.visible[5]}">Numeração</th>
					<th data-index="7" data-visible="${this.visible[6]}">Serial</th>
					<th data-index="8" data-visible="${this.visible[7]}">Fabricação</th>
					<th data-index="9" data-visible="${this.visible[8]}">Validade</th>
					<th data-index="10" data-visible="${this.visible[9]}">Quantidade</th>
					<th data-index="11" data-visible="${this.visible[10]}">Status</th>
					<th data-index="13" data-visible="${this.visible[11]}">Endereço</th>
				</tr>
			</thead>
			<tbody>
			` + (await Promise.all(records.map(async record => 
				`<tr data-id='${JSON.stringify([record.company_id, record.id])}'>
					<td><input type="checkbox"${this.isChecked(JSON.stringify([record.company_id, record.id]))}></td>
					<td data-visible='${this.visible[0]}'>${await this.key('companies', record.company_id, 'nick')}</td>
					<td data-visible='${this.visible[1]}'>${record.id}</td>
					<td data-visible='${this.visible[2]}'>${record.input_id}</td>
					<td data-visible='${this.visible[3]}'>${await this.key('products', [record.company_id, record.product_id])}</td>
					<td data-visible='${this.visible[4]}'>${record.program_id != null ? (await this.key('programs', [record.company_id, record.program_id]) || record.program_id) : '—'}</td>
					<td data-visible='${this.visible[5]}'>${formatLotNumber(record.lot_number)}</td>
					<td data-visible='${this.visible[6]}'>${record.serial ? String(record.serial) : ''}</td>
					<td data-visible='${this.visible[7]}'>${this.format(types.date(), record.manufacture_date)}</td>
					<td data-visible='${this.visible[8]}'>${this.format(types.date(), record.expiration_date)}</td>
					<td data-visible='${this.visible[9]}'>${this.format(types.number(0), record.quantity)}</td>
					<td data-visible='${this.visible[10]}'>${this.option(types.opt_lot_status(), record.status) || ''}</td>
					<td data-visible='${this.visible[11]}'>${record.location_address ? String(record.location_address) : '—'}</td>
				</tr>`
				))).join('') +
			`
			</tbody>
		</table>
	`;
};
